import { data } from '../../svg/Play/data';
import { makeIcon } from '../makeIcon';

export const Play = makeIcon(data, 'play', 'Play');

export default Play;
